@if (note) {
    <ddv-view-dashboard-note-button [label]="note.buttonLabel" (pressed)="showModal = true"></ddv-view-dashboard-note-button>
} @else {
   <cc-button
       [type]="'naked'"
       [icon]="{ name: 'plus-circle', size: 'medium' }"
       (pressed)="showModal = true"
   >
       Add Note
   </cc-button>
}

@if (showModal) {
    <ddv-dashboard-note-edit
        ccModal
        [note]="note"
        (cancelEdit)="showModal = false"
        (saveNote)="onSaveNote($event)"
        (deleteNote)="onDeleteNote()"
    >
    </ddv-dashboard-note-edit>
}
